<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.printMultiples.form.name')" prop="name" >
        <a-input v-model="form.name" :placeholder="$t('views.printMultiples.form.namePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.printMultiples.form.price')" prop="price" >
        <a-input-number v-model="form.price" style="width: 100%;" :min="0" :precision="2" :step="0.01" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.printMultiples.form.recyclingPrice')" prop="recyclingPrice" >
        <a-input-number v-model="form.recyclingPrice" style="width: 100%;" :min="0" :precision="2" :step="0.01" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.printMultiples.form.andDoubleNum')" prop="andDoubleNum" >
        <a-input-number v-model="form.andDoubleNum" style="width: 100%;" :min="0" :precision="2" :step="0.01" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.printMultiples.form.andBottomNum')" prop="andBottomNum" >
        <a-input-number v-model="form.andBottomNum" style="width: 100%;" :min="0" :precision="2" :step="0.01" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.printMultiples.form.andThreeNum')" prop="andThreeNum" >
        <a-input-number v-model="form.andThreeNum" style="width: 100%;" :min="0" :precision="2" :step="0.01" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.printMultiples.form.andFourNum')" prop="andFourNum" >
        <a-input-number v-model="form.andFourNum" style="width: 100%;" :min="0" :precision="2" :step="0.01" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.printMultiples.form.doubleDischarging')" prop="doubleDischarging" >
        <a-input-number v-model="form.doubleDischarging" style="width: 100%;" :min="0" :precision="2" :step="0.01" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.printMultiples.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.printMultiples.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPrintMultiples, addPrintMultiples, updatePrintMultiples } from '@/api/user/printMultiples'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        name: null,
        price: null,
        recyclingPrice: null,
        andDoubleNum: null,
        andBottomNum: null,
        andThreeNum: null,
        andFourNum: null,
        doubleDischarging: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false
    }
  },
  computed: {
    rules () {
      return {}
    }
  },
  watch: {
    '$i18n.locale' () {
      if (!this.open) return
      this.formTitle = this.formType === 2 ? this.$t('views.printMultiples.title.edit') : this.$t('views.printMultiples.title.add')
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        price: null,
        recyclingPrice: null,
        andDoubleNum: null,
        andBottomNum: null,
        andThreeNum: null,
        andFourNum: null,
        doubleDischarging: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('views.printMultiples.title.add')
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPrintMultiples({"id":id}).then(response => {
        const data = response.data || {}
        this.form = {
          ...this.form,
          ...data,
          recyclingPrice: data.recyclingPrice != null ? data.recyclingPrice : data.recycling_price
        }
        this.open = true
        this.formTitle = this.$t('views.printMultiples.title.edit')
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updatePrintMultiples(this.form).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.printMultiples.msg.updateOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.printMultiples.msg.updateFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPrintMultiples(this.form).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.printMultiples.msg.addOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.printMultiples.msg.addFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
